(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.lm-nav-disclosure').forEach((details)=>{
details.addEventListener('toggle',()=>{
if(details.open){document.querySelectorAll('.lm-nav-disclosure').forEach((other)=>{if(other!==details)other.open=false;});}
});
});
document.addEventListener('click',(event)=>{if(!event.target.closest('.lm-nav'))document.querySelectorAll('.lm-nav-disclosure').forEach((details)=>details.open=false);});
document.addEventListener('keydown',(event)=>{if(event.key==='Escape')document.querySelectorAll('.lm-nav-disclosure[open]').forEach((details)=>{details.open=false;details.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();
})();
